// import '@babel/polyfill'
// import '@/polyfill'
import 'core-js'
import 'regenerator-runtime/runtime'
import BiBase from 'bi-base'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins/validate'
import components from '@/components'
import api from './api'
import apiConfig from './api/apiConfig'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueTheMask from 'vue-the-mask'
import mixin from './mixin'
import { dialog } from './plugins'
import './stylus/main.styl'
// import FastClick from 'fastclick'
// import xss from 'xss'
import ESAPI from 'node-esapi'
import VueDOMPurifyHTML from 'vue-dompurify-html'
// 解決移動端300ms延遲
// FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.use(Vuetify, {
  theme: {
    primary: '#025DA3', // 主色 藍
    secondary: '#F26F28',
    info: '#6accc7',
    accent: '#025DA3',
    error: '#f95252',
    default: '#f5f5f5'
  }
})

Vue.use(BiBase, apiConfig)
Vue.use(components)
Vue.mixin(mixin)
Vue.use(dialog)
Vue.use(VueTheMask)
Vue.use(VueDOMPurifyHTML)
Object.defineProperties(Vue.prototype, {
  $api: {
    get () {
      return api
    }
  },
  $log: {
    get () {
      return console && console.log.bind(console)
    }
  },
  $xss: {
    get () {
      return myXssFilter
    }
  }
})

function myXssFilter (input) {
  return ESAPI.encoder().encodeForHTML(input)
}

store.dispatch('user/fetchUserInfo').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
    mounted () {
      document.addEventListener('visibilitychange', this.visibilitychange)
    },
    beforeDestroy () {
      document.removeEventListener('visibilitychange', this.visibilitychange)
    },
    methods: {
      visibilitychange () { // 擋另開分頁設計(對針分頁變更)
        if (!document.hidden && this.$store.getters['user/checkTabBlock']) {
          this.$store.dispatch('user/fetchUserInfo').then((r) => {
            let paras = {
              errorMsg: '已於其他分頁登入，無法再開啟新的分頁！'
            }
            if (r && r.status === 401) {
              // paras.errorMsg = '查無身分驗證資訊，請重新登入'
              // this.$router.goErrorMessage(paras)
              // 導到登入頁
              this.$router.goLogin()
            } else {
              if (this.$route.path !== '/login') {
                const isLogin = this.$store.getters['user/isLogin']
                if (!isLogin) {
                  // 導到登入頁
                  this.$router.goLogin()
                }
              }

              this.$store.dispatch('user/checkTabLogin').then(() => {
                if (this.$store.state.user.hadTabLogin && !this.$store.state.user.riPage) {
                  this.$router.goErrorMessage(paras)
                }
              })
            }
          })
        }
      }
    }
  }).$mount('#app')
})
